module.exports = __webpack_public_path__ + "static/media/Sorting_Icon.72945e47.svg";